import * as XLSX from "xlsx";

export const exportToExcelSheet = (data, schemes, totals, month, year, refreshTime) => {
  const wsData = [];

  const headerRow = ["Sl.No", "District", "Total Cards"];
  schemes.forEach((scheme) => {
    headerRow.push(`${scheme.schemeDesc} Cards`);
    headerRow.push(`${scheme.schemeDesc} Rice Sale`);
    headerRow.push(`${scheme.schemeDesc} Wheat Sale`);
  });
  headerRow.push("Total Cards", "Availed %", "Total Rice Sale", "Total Wheat Sale");
  wsData.push(headerRow);

  data.forEach((row, idx) => {
    const rowData = [
      idx + 1,
      row.distName || "-",
      row.totalCards || 0,
    ];

    const fields = row.dynamicFields || {};

    schemes.forEach((scheme) => {
      rowData.push(fields["scheme_" + scheme.schemeId] || 0);
      rowData.push(fields["rice_" + scheme.schemeId] || 0);
      rowData.push(fields["wheat_" + scheme.schemeId] || 0);
    });

    rowData.push(row.availPmgkayCards || 0);
    rowData.push(
      row.totalCards ? ((row.availPmgkayCards / row.totalCards) * 100).toFixed(2) : 0
    );
    rowData.push(row.pmgkaySale || 0);
    rowData.push(row.pmgkayWheatSale || 0);

    wsData.push(rowData);
  });

  const totalRow = ["Total", "", totals.totalCards || 0];

  schemes.forEach((scheme) => {
    totalRow.push(totals["scheme_" + scheme.schemeId] || 0);
    totalRow.push(totals["rice_" + scheme.schemeId] || 0);
    totalRow.push(totals["wheat_" + scheme.schemeId] || 0);
  });

  totalRow.push(totals.availPmgkayCards || 0);
  totalRow.push(
    totals.totalCards ? ((totals.availPmgkayCards / totals.totalCards) * 100).toFixed(2) : 0
  );
  totalRow.push(totals.pmgkaySale || 0);
  totalRow.push(totals.pmgkayWheatSale || 0);

  wsData.push(totalRow);

  const totalColumns = headerRow.length;
  const refreshRow = new Array(totalColumns).fill("");
  refreshRow[totalColumns - 1] = `Refresh Time: ${refreshTime}`; // bottom-right
  wsData.push(refreshRow);

  const ws = XLSX.utils.aoa_to_sheet(wsData);

  const wscols = headerRow.map(() => ({ wpx: 120 }));
  ws['!cols'] = wscols;

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "PMGKAY Summary");
  XLSX.writeFile(wb, `PMGKAY_Summary_${month}_${year}.xlsx`);
};
